import autoBind from 'react-autobind';
import { Field, reduxForm } from 'redux-form';
import React, { Component } from 'react';
import moment from 'moment';
import { renderInput, renderInputNumber } from 'src/components/misc/redux-form-helpers';
import { getLocalizedValue } from 'src/utils/helpers';

class AdminRatingReviewForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            editCustomerCommentButton: this.props.review.visible,
            tableTitle: this.props.review.visible,
            startedFetching: false,
        };
    }

    render() {
        const { review, t, initialValues, handleSubmit, reviewCategories } = this.props;

        const ratingsEditable =
            Object.entries(review.entries).filter(([key, val]) => val === 0).length ===
            Object.keys(review.entries).length;

        const displayField = this.props.filter === 'REVIEW_NEEDS_APPROVAL' ? 'comment' : 'operatorAnswer';
        const reviewView = this.props.filter === 'REVIEW_NEEDS_APPROVAL';

        const fieldDisabled = displayField === 'comment' ? review.visible : false;

        const label = reviewView
            ? t('administration.task_ratings.customer_comment')
            : t('administration.task_ratings.answer');

        return (
            <div>
                <form role="form" className="voffset" onSubmit={handleSubmit}>
                    <div>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <label>{label}</label>
                                    <Field
                                        name={displayField}
                                        label={label}
                                        hintText={label}
                                        component={renderInput}
                                        rows={3}
                                        maxRows={3}
                                        multiline
                                        disabled={fieldDisabled}
                                        fullWidth={true}
                                    />
                                </div>
                            </div>
                            <div className="row voffset">
                                <div className="col-md-6">{this.getReviewInfo(review.entries, ratingsEditable)}</div>
                                <div className="col-md-6">
                                    {this.getTaskDetails(review)}
                                    <p>{t('administration.task_ratings.operator_infos')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    getReviewInfo(entries, ratingsEditable) {
        const { t, i18n, reviewCategories } = this.props;

        // if not all categories are rated, add missing categories and make the review editable
        let items = { ...entries };
        if (Object.keys(entries).length !== reviewCategories.items.length) {
            reviewCategories.items.forEach(item => {
                if (!items[item.id]) items[item.id] = 0.0;
            });
            ratingsEditable = true;
        }
        // find localized review category names
        const localized = Object.entries(items).map(([key, value]) => {
            const category = reviewCategories.items.find(c => c.id === Number(key));
            return {
                id: key,
                name: getLocalizedValue(category.name, i18n.language),
                value,
            };
        });
        return (
            <>
                <table className="table table-striped" style={{ padding: 0 }}>
                    <thead>
                        <tr>
                            <td style={{ padding: 0 }}>
                                <label>{t('administration.task_ratings.category')}</label>
                            </td>
                            <td style={{ padding: 0 }}>
                                <label>{t('administration.task_ratings.evaluation')}</label>
                            </td>
                        </tr>
                    </thead>
                    <tbody className="small">
                        {localized.map(entry => (
                            <tr key={entry.id} style={{ padding: 0 }}>
                                <td style={{ padding: 0 }}>{entry.name}</td>
                                <td className="td" style={{ padding: 0 }}>
                                    <Field
                                        style={{ fontSize: '9pt' }}
                                        name={`entries.${entry.id}`}
                                        value={entry.value}
                                        component={renderInputNumber}
                                        type="number"
                                        step={0.5}
                                        max={5}
                                        min={0.5}
                                        disabled={!ratingsEditable}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    }

    getTaskDetails(review) {
        const { task, customer } = review;
        const { t } = this.props;
        return (
            <div>
                <label>{t('administration.task_ratings.task_infos')}</label>
                <table className="table table-striped">
                    <tbody>
                        <tr>
                            <td>Datum:</td>
                            <td>
                                {moment(task.taskFrom.time).format()} - {task.bookingIdentifier}
                            </td>
                        </tr>
                        <tr>
                            <td>Kunde:</td>
                            <td>{customer.contactData.email}</td>
                        </tr>
                        <tr>
                            <td width="15%">Von:</td>
                            <td>{task.taskFrom.location.address}</td>
                        </tr>
                        <tr>
                            <td>Nach:</td>
                            <td>{task.taskTo.location.address}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

const validate = (values, props) => {
    const { t, reviewCategories } = props;
    const errors = {
        entries: {},
    };

    reviewCategories.items.forEach(category => {
        const rating = Object.entries(values.entries).find(value => Number(value[0]) === category.id);
        if (!rating || rating.value < 0.5)
            errors.entries[category.id] = t('administration.task_ratings.error_rating_review');
    });

    return errors;
};

export default reduxForm({
    form: 'AdminRatingReviewForm',
    validate,
})(AdminRatingReviewForm);
